import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { AssignmentAvailabilityStatus } from '@wilson/interfaces';
import { firstValueFrom } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { FilterQualifiedStaffChangedButtonComponent } from '../filter-qualified-staff-changed-button/filter-qualified-staff-changed-button.component';
import { TimelineModalFilterService } from '../../services/timeline-modal-filter.service';
import { FilterQualifiedWorkingTimeStaffChangedButtonComponent } from '../filter-qualified-working-time-staff-changed-button/filter-qualified-working-time-staff-changed-button.component';
import { NzButtonModule } from 'ng-zorro-antd/button';
@Component({
  selector: 'wilson-find-shift-staff-quick-filter',
  imports: [
    CommonModule,
    TranslateModule,
    NzButtonModule,
    FilterQualifiedStaffChangedButtonComponent,
    FilterQualifiedWorkingTimeStaffChangedButtonComponent,
  ],
  templateUrl: './find-shift-staff-quick-filter.component.html',
  styleUrls: ['./find-shift-staff-quick-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FindShiftStaffQuickFilterComponent {
  private readonly cdRef = inject(ChangeDetectorRef);
  timelineModalFilterService = inject(TimelineModalFilterService);

  AssignmentAvailabilityStatus = AssignmentAvailabilityStatus;

  async staffAvailabilityChanged() {
    const currentAvailabilityFilter = await firstValueFrom(
      this.timelineModalFilterService.staffAvailability$,
    );

    let nextAvailabilityFilter = AssignmentAvailabilityStatus.Available;

    switch (currentAvailabilityFilter) {
      case AssignmentAvailabilityStatus.Available:
        nextAvailabilityFilter = AssignmentAvailabilityStatus.NotAvailable;
        break;
    }

    this.timelineModalFilterService.staffAvailabilityChanged(
      nextAvailabilityFilter,
    );
    this.cdRef.detectChanges();
  }
}
